import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, getArticlesByCategory } from '@/mocks/articles';
import { useState } from 'react';

const articleCategories = [
  { name: '全部', slug: 'all' },
  { name: '玩法攻略', slug: 'lottery-guide' },
  { name: '中奖故事', slug: 'winner-stories' },
  { name: '行业资讯', slug: 'industry-news' },
  { name: '新手必读', slug: 'newbie-guide' },
];

export default function ArticlesPage() {
  const [activeCategory, setActiveCategory] = useState('all');

  const displayArticles = activeCategory === 'all'
    ? articles
    : getArticlesByCategory(activeCategory);

  const handleCategoryChange = (slug: string) => {
    setActiveCategory(slug);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <section className="w-full px-4 md:px-6 py-8 bg-background-50">
          <Breadcrumb items={[{ label: '彩票资讯', path: '/articles' }]} />
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
                彩票资讯
              </h1>
              <p className="text-foreground-600 text-sm">
                掌握行业动态，了解最新玩法攻略与中奖故事
              </p>
            </div>

            <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8 flex-wrap">
              {articleCategories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleCategoryChange(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            {displayArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {displayArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}